<!-- Page header -->
<div class="page-header">
  <div class="page-header-content">
    <div class="page-title" style="padding-bottom: 0px;">
  <h4>
    <!--<i class="icon-arrow-left52 position-left"></i>-->
    <span class="text-semibold">Welcome {{titleName}} 
      <!-- {{userName}} -->
    </span>

    <a *ngIf="currentRoute == 'cems' || userLevel == 'admin'" title="Archived Industry List" [routerLink]="['/archive-industry']" class="btn btn-sm btn-primary" style="float: right;">
      <strong> <i class="fa fa-archive"></i> Archived Unit</strong>
    </a>

    <!--<small class="display-block">Good morning, Victoria Baker!</small>-->
  </h4>
</div>
</div>
</div>
<!-- /page header -->
